module.exports = __webpack_public_path__ + "img/785671247.d66494bc.jpg";